import { render, staticRenderFns } from "./UploadCatalogCoverForm.vue?vue&type=template&id=888c133a&scoped=true&"
import script from "./UploadCatalogCoverForm.vue?vue&type=script&lang=js&"
export * from "./UploadCatalogCoverForm.vue?vue&type=script&lang=js&"
import style0 from "./UploadCatalogCoverForm.vue?vue&type=style&index=0&id=888c133a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "888c133a",
  null
  
)

export default component.exports